import { ACCOUNT_MODE } from '@bingads-webui-campaign/campaign-ui-common';
import { Products, AppScope } from './constants';

/**
 * Account mode is not very accurate on identifying what the real product is
 * because sometime one AccountMode can represent multiple product, and some product has
 * multiple AccountMode in DB (historical reasons).
 * @param {object} serverContext - server context
 * @returns {string} - real product, e.g Expert, Smart, DMC, UP
 */
export const getProduct = (serverContext) => {
  const {
    CurrentAccount,
    CurrentCustomer,
  } = serverContext;

  if (CurrentCustomer && CurrentCustomer.AppScope === AppScope.DMC) {
    return Products.DMC;
  }

  if (CurrentAccount) {
    const { AccountMode } = CurrentAccount;
    switch (AccountMode) {
      case ACCOUNT_MODE.DEFAULT:
      case ACCOUNT_MODE.EXPERT:
        return Products.Expert;
      case ACCOUNT_MODE.SMART:
        return Products.Smart;
      case ACCOUNT_MODE.UNIFIED_SMART:
        return Products.UP;

      default: throw new Error(`Invalid account mode: ${AccountMode}`);
    }
  }

  return Products.Unknown;
};
